/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable no-unused-vars */
import actions from 'redux-auto'
import i18n from 'i18next'
import Api from '#services/api'

export function pending(state) {
  return {
    ...state,
    isLoading: true,
  }
}

export function fulfilled(state, payload) {
  return {
    ...state,
    error: undefined,
    isLoading: false,
    answers: removeAnswerByFrageId(state.answers, payload.frageId),
  }
}

export function rejected(state, pl, error) {
  return {
    ...state,
    isLoading: false,
    error: error && error.message ? error.message : i18n.t('misc_unknown_error'),
  }
}

export async function action(payload) {
  try {
    return await Api.deleteImage(payload)
  } catch (e) {
    actions.error.writeError({error: e})
    throw new Error(i18n.t(e.message))
  }
}

const removeAnswerByFrageId = (answers, frageId) => {
  const result = {}
  for (const chapter in answers) {
    const resultChapter = {}
    for (const frage in answers[chapter]) {
      if (frage !== frageId) {
        resultChapter[frage] = answers[chapter][frage]
      }
    }
    result[chapter] = resultChapter
  }
  return result
}
